import React, { useState } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import { debtorService } from '../../services/debtorService';
import { useNotification } from '../../hooks/useNotification';

const DeleteDebtorModal = ({ isOpen, onClose, debtor, onSuccess }) => {
  const { showSuccess, showError } = useNotification();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);

    try {
      await debtorService.delete(debtor._id);
      showSuccess('Debtor deleted successfully!');
      onClose();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error deleting debtor:', error);
      showError(error.message || 'Failed to delete debtor. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Debtor">
      <div className="mb-6">
        <div className="flex items-center justify-center mb-4">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
        </div>

        <h3 className="text-lg font-medium text-gray-900 text-center mb-2">
          Delete {debtor?.name}?
        </h3>

        <p className="text-sm text-gray-600 text-center mb-4">
          Are you sure you want to delete this debtor?
        </p>

        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-sm text-red-800">
            <strong>Warning:</strong> All transaction history will be permanently deleted. This action cannot be undone.
          </p>

          {debtor && debtor.totalOutstanding > 0 && (
            <p className="text-sm text-red-800 mt-2">
              <strong>Outstanding balance:</strong> {debtor.totalOutstanding.toFixed(3)} BHD
            </p>
          )}
        </div>
      </div>

      <div className="flex gap-3 justify-end">
        <Button type="button" variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="button"
          variant="danger"
          loading={loading}
          onClick={handleDelete}
        >
          Delete Permanently
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteDebtorModal;
